import Route from '@ember/routing/route';

export default class ForbiddenRoute extends Route {
  activate() {
    super.activate(...arguments);
    window.scrollTo(0, 0);
  }
}
